
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class ModalConfirmDelete extends Vue {
  /* VUEX */

  /* PROPS */
  @Prop({ default: false })
  private isShow: boolean;
  @Prop({ default: false })
  private tracer: any;
  @Prop({ default: false })
  private isQuestion: boolean;

  /* METHODS */
  private clickSubmit() {
    this.$emit("onConfirmed", this.tracer);
    this.$emit("update:isShow", false);
  }
}
